import { useState } from 'react'

export default function useTasks() {

  const storageKey = 'todoTasks';

  const load = () => {
    const item = localStorage.getItem(storageKey);
    if (item && item !== 'undefined') {
      return JSON.parse(item);
    }
    else {
      return [];
    }
  }

  const save = (data) => {
    localStorage.setItem(storageKey, JSON.stringify(data));
    setState(data);
  }

  const [getState, setState] = useState(load);

  return {        
    tasks: getState,
    setTasks: save
  }
}
